import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
	Box,
	Checkbox,
	FormControlLabel,
	Grid,
	Paper,
	Radio,
	RadioGroup,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import { ButtonCompo } from "../../components/Comman/Button";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import endpoint from "../../config/endpoints";
import * as myConstClass from "../../config/messageconstant";

import { compose } from "recompose";
import { TextFieldCompo } from "../../components/Comman/TextFieldCompo";
import { withRouter } from "../../components/withRouter";
import {
	checkedListEmptyMsg,
	noInternetMsg,
	saveWarningMsg,
} from "../../config/messageconstant";
import { assignBeatJson } from "../../DynamicFormsJson/Transaction/assignBeat";
import {
	getReportingManagerHierarchy,
	setReportingManagerHierarchy,
} from "../../Slice/salesExecutive.slice";
import { apiPost } from "../../utils/api_service";
import NoDataFound from "../DashbourdChanges/NoDataFound";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import SearchBar from "../../components/Search";
import { white } from "../../config/ColorObj";

class BeatAssignationBySalesTeamWise extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			salesTeamId: "",
			areaId: "",
			setList: [],
			checkList: [],
			isError: false,
			areaName: "",
			salesTeamName: "",
			searchValue: "",
			open: false,
			DataToSet: [],
			adminFlag: false,
			expanded: {},
			dataResponse: [],
			dynamicMasterData: {},
		};
	}

	async componentDidMount() {
		const {
			showLoador,
			showNotification,
			salesTeamId,
			getReportingManagerHierarchy,
			checkedBeatList,
			salesExecutivData,
			checkedBeatNames,
			areaListForName,
		} = this.props;

		if (navigator.onLine) {
			if (checkedBeatNames.length !== 0 && areaListForName.length !== 0) {
				const commaSeparatedAreaNames = areaListForName
					.map((areaObj) => areaObj.name)
					.join(", ");
				const commaSeparatedBeatNames = checkedBeatNames.join(", ");

				this.setState({
					DataToSet: [
						{
							xs: 12,
							sm: 4,
							md: 4,
							lg: 4,
							label: "Sales Team",
							value:
								salesExecutivData !== null &&
								salesExecutivData.salesTeamName !== null
									? salesExecutivData.salesTeamName
									: "-",
						},
						{
							xs: 12,
							sm: 4,
							md: 4,
							lg: 4,
							label: "Area Name",
							value:
								commaSeparatedAreaNames !== null
									? commaSeparatedAreaNames
									: "-",
						},
						{
							xs: 12,
							sm: 4,
							md: 4,
							lg: 4,
							label: "No Of Beats",
							value: checkedBeatNames.length,
						},
						{
							md: 12,
							lg: 12,
							sm: 12,
							xs: 12,
							labelXS: 12,
							labelSM: 1.3,
							labelMD: 1.3,
							labelLG: 1.3,
							valueXS: 12,
							valueSM: 10,
							valueMD: 10,
							valueLG: 10,
							label: "Beat Names",
							value:
								commaSeparatedBeatNames !== null
									? commaSeparatedBeatNames
									: "-",
						},
					],
				});
			} else if (areaListForName.length !== 0) {
				const commaSeparatedAreaNames = areaListForName
					.map((areaObj) => areaObj.name)
					.join(", ");

				this.setState({
					DataToSet: [
						{
							xs: 12,
							sm: 4,
							md: 4,
							lg: 4,
							label: "Sales Team",
							value:
								salesExecutivData !== null &&
								salesExecutivData.salesTeamName !== null
									? salesExecutivData.salesTeamName
									: "-",
						},
						{
							xs: 12,
							sm: 4,
							md: 4,
							lg: 4,
							label: "Area Name",
							value:
								commaSeparatedAreaNames !== null
									? commaSeparatedAreaNames
									: "-",
						},
					],
				});
			}

			let dataToSend = {};

			if (checkedBeatList.length !== 0 && salesTeamId) {
				const beatIds = checkedBeatList
					.map((dataObj) => dataObj.beat.id)
					.join(",");

				dataToSend = {
					salesTeamId: salesTeamId,
					beatIds: beatIds.split(","),
				};
			} else if (salesTeamId) {
				dataToSend = {
					salesTeamId: salesTeamId,
					beatIds: [],
				};
			}

			showLoador({ loador: true });
			getReportingManagerHierarchy({ dataJson: dataToSend }).then(
				({ response, success }) => {
					showLoador({ loador: false });
					if (!success) {
						showNotification({
							msg: myConstClass.serverMsg,
							severity: "error",
						});
					} else {
						this.setState({
							dataResponse: response,
						});
					}
				},
			);
		} else {
			this.props.showNotification({ msg: noInternetMsg, severity: "error" });
		}
	}

	onSubmit = () => {
		const { checkedBeatList, showLoador, showNotification } = this.props;
		const { salesTeamId, dataResponse } = this.state;
		let filterBeatList = [];
		let beatAssignList = [];
		let hasError = false;
		let dataJson = {};

		const checkedList = dataResponse.filter((row) => row.isChecked);

		if (checkedBeatList.length !== 0) {
			dataResponse.length != 0 &&
				dataResponse.map((dataObject) => {
					if (dataObject.isChecked) {
						dataObject.beatAssigns.map((beatObj) => {
							if (beatObj.isChecked) {
								if (beatObj.isError) {
									hasError = true;
								}
								const beatListObjectToSave = {
									beat: {
										id: beatObj.beatId,
									},
									salesTeam: {
										id: dataObject.id,
									},
									beatType: +beatObj.beatType,
									beatSubType: +beatObj.beatSubType || 0,
									ratePerKm: beatObj.ratePerKm ? +beatObj.ratePerKm : 0,
									dailyAllowance: beatObj.dailyAllowance
										? +beatObj.dailyAllowance
										: 0,
									distanceFromHq: beatObj.distance ? +beatObj.distance : 0,
									selfAssign: beatObj.selfAssign ? beatObj.selfAssign : 0,
									isActive: 1,
								};
								filterBeatList.push(beatListObjectToSave);
							}
						});
					}
				});
		} else {
			dataResponse.length != 0 &&
				dataResponse.map((dataObject) => {
					if (dataObject.isChecked) {
						dataObject.beatAssigns.map((beatObj) => {
							if (beatObj.isChecked) {
								if (beatObj.isError) {
									hasError = true;
								}
								const beatListObjectToSave = {
									id: beatObj.id,
									beat: {
										id: beatObj.beatId,
									},
									salesTeam: {
										id: dataObject.id,
									},
									beatType: +beatObj.beatType,
									beatSubType: +beatObj.beatSubType || 0,
									ratePerKm: beatObj.ratePerKm ? +beatObj.ratePerKm : 0,
									selfAssign: beatObj.selfAssign ? beatObj.selfAssign : 0,
									dailyAllowance: beatObj.dailyAllowance
										? +beatObj.dailyAllowance
										: 0,
									distanceFromHq: beatObj.distance ? +beatObj.distance : 0,
									isActive: 1,
								};
								beatAssignList.push(beatListObjectToSave);
							}
						});
					}
				});

			dataJson = {
				salesTeamIds: dataResponse
					.filter((row) => row.isChecked)
					.map((obj) => obj.id),
				beatAssigns: beatAssignList,
			};
		}

		if (checkedList.length !== 0) {
			if (checkedBeatList.length !== 0) {
				if (filterBeatList.length !== 0) {
					if (!hasError) {
						swal({
							title: "Are you sure?",
							text: saveWarningMsg,
							icon: "warning",
							buttons: true,
							dangerMode: true,
						}).then(async(willDelete) => {
							if (willDelete) {
								showLoador({ loador: true });
								await apiPost({
									url: endpoint.assignBeat + "/save",
									postBody: filterBeatList,
								}).then(({ success }) => {
									showLoador({ loador: false });
									if (success) {
										showNotification({
											msg: myConstClass.savemsg,
										});

										this.onSkip();
									} else {
										showNotification({
											msg: myConstClass.saveFailedMsg,
											severity: "error",
										});
									}
								});
							}
						});
					} else {
						showNotification({
							msg: "Please check the mandatory fields in the table.",
							severity: "error",
						});
					}
				}
			} else {
				if (!hasError) {
					swal({
						title: "Are you sure?",
						text: saveWarningMsg,
						icon: "warning",
						buttons: true,
						dangerMode: true,
					}).then(async(willDelete) => {
						if (willDelete) {
							showLoador({ loador: true });
							await apiPost({
								url: endpoint.assignBeat + "/delete-existing-and-save",
								postBody: dataJson,
							}).then(({ success }) => {
								showLoador({ loador: false });
								if (success) {
									showNotification({
										msg: myConstClass.savemsg,
									});
									this.onSkip();
								} else {
									showNotification({
										msg: myConstClass.saveFailedMsg,
										severity: "error",
									});
								}
							});
						}
					});
				} else {
					showNotification({
						msg: "Please check the mandatory fields in the table.",
						severity: "error",
					});
				}
			}
		} else {
			showNotification({
				msg: checkedListEmptyMsg,
				severity: "error",
			});
		}
	};

	onSkip = () => {
		window.location.replace("/assign-beat-allowance-wise");
	};

	handleClick = (e, id) => {
		const { dataResponse } = this.state;
		const isChecked = e.target.checked;

		let salesTeamObject = dataResponse?.find((row) => row.id == id);

		const updatedData = dataResponse?.map((item) => {
			if (item.id === id) {
				return {
					...item,
					isChecked: isChecked,
					beatAssigns: item.beatAssigns.map((beatObj) => ({
						...beatObj,
						isChecked: isChecked,
					})),
				};
			}

			return item.index < salesTeamObject.index && isChecked
				? {
						...item,
						isChecked: true,

						beatAssigns: item.beatAssigns.map((beatObj) => ({
							...beatObj,
							isChecked: true,
						})),
					}
				: item;
		});
		this.setState({ dataResponse: updatedData });
	};

	handleExpandClick = (id) => {
		this.setState((prevState) => {
			const { expanded } = prevState;
			return {
				expanded: {
					...expanded,
					[id]: !expanded[id],
				},
			};
		});
	};

	changeHandler = (row, name) => (e) => {
		const { dataResponse } = this.state;
		const { name, value, placeholder } = e.target;

		const updatedList = dataResponse.map((dataObj) => {
			if (dataObj.beatAssigns.some((beatObj) => beatObj.id === row.id)) {
				return {
					...dataObj,
					beatAssigns: dataObj.beatAssigns.map((beatObj) =>
						beatObj.id === row.id
							? {
									...beatObj,
									[name]: value,
									[`${name}Error`]:
										value.trim() === "" ? `${placeholder} cannot be empty` : "",
									isError: value.trim() === "" ? true : false,
								}
							: beatObj,
					),
				};
			}
			return dataObj;
		});

		this.setState({ dataResponse: updatedList });
	};

	changeRadioHandler = (e, id) => {
		const { dataResponse } = this.state;
		const beatSubType = +e.target.value;

		const updatedList = dataResponse.map((dataObj) => ({
			...dataObj,
			beatAssigns: dataObj.beatAssigns.map((beatObj) =>
				beatObj.id === id
					? {
							...beatObj,
							beatSubType,
						}
					: beatObj,
			),
		}));

		this.setState({ dataResponse: updatedList });
	};

	handleClickForTableCheckBox = (e, id) => {
		const { dataResponse } = this.state;
		let dataList = dataResponse.map((dataObj) => {
			if (dataObj.beatAssigns.some((beatObj) => beatObj.id === id)) {
				return {
					...dataObj,
					beatAssigns: dataObj.beatAssigns.map((beatObj) =>
						beatObj.id === id
							? {
									...beatObj,
									isChecked: e.target.checked,
								}
							: beatObj,
					),
				};
			}
			return dataObj;
		});
		this.setState({ dataResponse: dataList });
	};

	handleAllCheckedClick = (e, id) => {
		const { dataResponse } = this.state;
		const isChecked = e.target.checked;

		const updatedList = dataResponse.map((dataObj) => {
			if (dataObj.id === id) {
				return {
					...dataObj,
					isChecked: isChecked,
					beatAssigns: dataObj.beatAssigns.map((beatObj) => ({
						...beatObj,
						isChecked,
					})),
				};
			}
			return dataObj;
		});

		this.setState({
			dataResponse: updatedList,
		});
	};

	onSearchBox = (searchValue) => {
		this.setState({
			searchValue: searchValue,
		});
	};

	getFilteredTableData = (searchData) => {
		const { searchValue } = this.state;
		return searchData.filter((currentRow) => {
			let isValid = false;
			if (
				(currentRow["beatName"] &&
					currentRow["beatName"]
						.toString()
						.toLowerCase()
						.includes(searchValue.trim().toLowerCase())) ||
				(currentRow["areaName"] &&
					currentRow["areaName"]
						.toString()
						.toLowerCase()
						.includes(searchValue.trim().toLowerCase()))
			) {
				isValid = true;
				return true;
			}
		});
	};

	render() {
		const {
			dynamicMasterData,
			expanded,
			dataResponse,
			DataToSet,
			searchValue,
		} = this.state;
		return (
			<>
				<Paper
					sx={{
						padding: 2,
					}}
					elevation={0}
				>
					<DynamicFormWithoutSave
						DataToSet={DataToSet}
						dynamicMasterData={dynamicMasterData}
						showSaveBtn={false}
						showSaveBtnMain={false}
						showTitle={false}
						screenTitle={""}
						fieldMeta={[]}
						showCancel={assignBeatJson.showCancel}
						apiBaseURL={assignBeatJson.apiBaseURL}
						showSaveNextBtn={false}
						saveBtnText={"Search"}
						onSave={this.onSearch}
					/>
					<>
						{dataResponse.length !== 0 ? (
							<>
								<Box
									sx={{
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										mt: 3,
									}}
								>
									{dataResponse?.map((dataObj, index) => (
										<React.Fragment key={index}>
											{/* Card showing the name */}
											<Box
												sx={{
													width: "1200px",
													maxWidth: "1200px",
													minHeight: "100px",
													padding: "12px 16px",
													background: "#ffffff",
													border: "1px solid #90caf9",
													borderRadius: "12px",
													boxShadow: "0 3px 10px rgba(202, 255, 255, 0.61)",
													display: "flex",
													flexDirection: "column",
													alignItems: "center",
													transition: "transform 0.3s ease",
													"&:hover": {
														transform: "scale(1.03)",
														boxShadow: "0 10px 22px rgba(122, 126, 129, 0.3)",
													},
												}}
											>
												{/* Checkbox and Name */}
												<Box
													sx={{
														display: "flex",
														alignItems: "center",
														width: "100%",
														justifyContent: "center",
													}}
												>
													<Box
														sx={{
															width: "40px",
															display: "flex",
															justifyContent: "center",
														}}
													>
														<Checkbox
															color="primary"
															onClick={(event) =>
																this.handleClick(event, dataObj.id)
															}
															checked={
																dataObj.isChecked ||
																dataObj.beatAssigns.every(
																	(beatObj) => beatObj.isChecked,
																)
															}
															inputProps={{
																"aria-labelledby": `enhanced-table-checkbox-${index}`,
															}}
														/>
													</Box>
													<Typography
														sx={{
															fontSize: "17px",
															fontWeight: 450,
															color: "#0d47a1",
															whiteSpace: "nowrap",
															overflow: "hidden",
															textOverflow: "ellipsis",
														}}
													>
														{dataObj.name}
													</Typography>
												</Box>

												<ExpandMoreIcon
													sx={{
														fontSize: 32,
														color: "#1976d2",
														cursor: "pointer",
														transition: "transform 0.3s ease",
														transform: expanded[dataObj.id]
															? "rotate(180deg)"
															: "rotate(0deg)",
														mt: 1,
													}}
													onClick={() => this.handleExpandClick(dataObj.id)}
												/>

												{/* Expanded Content */}
												{expanded[dataObj.id] && (
													<Box
														sx={{
															p: 2,
														}}
													>
														<Grid item xs={12}>
															<Box sx={{ width: "300px" }}>
																<SearchBar
																	placeHolder="Search..."
																	inputProps={{ "aria-label": "search" }}
																	searchValue={searchValue}
																	filteredRows={this.onSearchBox}
																/>
															</Box>
														</Grid>
														<Grid item xs={12}>
															<TableContainer
																style={{ maxHeight: "500px", overflow: "auto" }}
															>
																<Table stickyHeader aria-label="sticky table">
																	<TableHead>
																		<TableRow>
																			<TableCell
																				padding="checkbox"
																				align="center"
																				width="5%"
																			>
																				<Checkbox
																					color="error"
																					checked={dataObj.beatAssigns.every(
																						(beatObj) => beatObj.isChecked,
																					)}
																					onChange={(event) =>
																						this.handleAllCheckedClick(
																							event,
																							dataObj.id,
																						)
																					}
																					inputProps={{
																						"aria-label": "select all beats",
																					}}
																				/>
																			</TableCell>
																			<TableCell align="center" width="5%">
																				Sr. No.
																			</TableCell>
																			<TableCell align="center" width="12%">
																				Beat Name
																			</TableCell>
																			<TableCell align="center" width="12%">
																				Area Name
																			</TableCell>
																			<TableCell align="center" width="12%">
																				Beat Distance(KM)
																			</TableCell>
																			<TableCell align="center" width="10%">
																				Beat Type
																			</TableCell>
																			<TableCell align="center" width="10%">
																				Rate per KM
																			</TableCell>
																			<TableCell align="center" width="12%">
																				Daily Allowance
																			</TableCell>
																			<TableCell align="center" width="10%">
																				Travelling Allowance
																			</TableCell>
																			<TableCell align="center" width="10%">
																				Total
																			</TableCell>
																		</TableRow>
																	</TableHead>
																	<TableBody>
																		{dataObj?.beatAssigns.length !== 0 ? (
																			this.getFilteredTableData(
																				dataObj?.beatAssigns,
																			)?.map((row, index) => (
																				<TableRow key={row.id}>
																					<TableCell
																						padding="checkbox"
																						align="center"
																					>
																						<Checkbox
																							color="primary"
																							onClick={(event) =>
																								this.handleClickForTableCheckBox(
																									event,
																									row.id,
																								)
																							}
																							checked={row.isChecked}
																							disabled={false}
																							inputProps={{
																								"aria-labelledby": `enhanced-table-checkbox-${index}`,
																							}}
																						/>
																					</TableCell>
																					<TableCell align="center">
																						{index + 1}
																					</TableCell>
																					<TableCell align="left">
																						{row.beatName}
																					</TableCell>
																					<TableCell align="left">
																						{row.areaName}
																					</TableCell>

																					<TableCell align="center">
																						<TextFieldCompo
																							placeHolder="Beat Distance(KM)"
																							color="primary"
																							type="number"
																							name="distance"
																							id={`distance-${row.id}`}
																							size="small"
																							value={row.distance}
																							fullWidth
																							onChange={this.changeHandler(
																								row,
																								"distance",
																							)}
																							errorText={
																								row.distanceError || ""
																							}
																						/>
																					</TableCell>
																					{row.beatType == 1 ? (
																						<>
																							<TableCell align="center">
																								-
																							</TableCell>
																						</>
																					) : (
																						<>
																							<TableCell align="left">
																								<RadioGroup
																									row
																									aria-label="Type"
																									name="beatType"
																									id={`beatType-${row.id}`}
																									value={row.beatSubType}
																									onChange={(event) =>
																										this.changeRadioHandler(
																											event,
																											row.id,
																										)
																									}
																									size="small"
																								>
																									<FormControlLabel
																										value={0}
																										control={<Radio />}
																										label="Local"
																									/>
																									<FormControlLabel
																										value={1}
																										control={<Radio />}
																										label="Outstation"
																									/>
																								</RadioGroup>
																							</TableCell>
																						</>
																					)}

																					<TableCell align="center">
																						<TextFieldCompo
																							placeHolder="Rate Per KM"
																							color="primary"
																							type="number"
																							name="ratePerKm"
																							id={`ratePerKm-${row.id}`}
																							size="small"
																							value={row.ratePerKm}
																							fullWidth
																							onChange={this.changeHandler(
																								row,
																								"ratePerKm",
																							)}
																							errorText={
																								row.ratePerKmError || ""
																							}
																						/>
																					</TableCell>
																					<TableCell>
																						<TextFieldCompo
																							placeHolder="Daily Allowance"
																							color="primary"
																							type="number"
																							name="dailyAllowance"
																							id={`dailyAllowance-${row.id}`}
																							size="small"
																							value={row.dailyAllowance}
																							fullWidth
																							onChange={this.changeHandler(
																								row,
																								"dailyAllowance",
																							)}
																							errorText={
																								row.dailyAllowanceError || ""
																							}
																						/>
																					</TableCell>
																					<TableCell align="right">
																						{(
																							+row.ratePerKm * +row.distance
																						).toFixed(2)}
																					</TableCell>
																					<TableCell align="right">
																						{(
																							+row.dailyAllowance +
																							+row.ratePerKm * +row.distance
																						).toFixed(2)}
																					</TableCell>
																				</TableRow>
																			))
																		) : (
																			<TableRow>
																				<TableCell colSpan={10} align="center">
																					<Typography
																						variant="h7"
																						color="textSecondary"
																						sx={{ whiteSpace: "nowrap" }}
																					>
																						No data found
																					</Typography>
																				</TableCell>
																			</TableRow>
																		)}
																	</TableBody>
																</Table>
															</TableContainer>
														</Grid>
													</Box>
												)}
											</Box>

											{/* Arrow + Label (skip after last item) */}
											{index !== dataResponse?.length - 1 && (
												<Box
													sx={{
														my: 2,
														display: "flex",
														flexDirection: "column",
														alignItems: "center",
														animation: "fadeIn 0.6s ease-in-out",
													}}
												>
													<ArrowDownwardIcon
														sx={{
															fontSize: 34,
															color: "#1976d2",
															transition: "transform 0.3s ease",
															"&:hover": {
																transform: "translateY(4px)",
																color: "#0d47a1",
															},
														}}
													/>
													<Typography
														variant="caption"
														sx={{ fontSize: 13, color: "#1976d2", mt: 0.5 }}
													>
														Reporting To
													</Typography>
												</Box>
											)}
										</React.Fragment>
									))}
								</Box>
							</>
						) : (
							<NoDataFound />
						)}
					</>

					<Grid
						item
						sm={12}
						xs={12}
						md={12}
						lg={12}
						rowSpacing={2}
						columnSpacing={{ xs: 12, sm: 6, md: 1 }}
						container
						justifyContent="right"
						marginTop={5}
					>
						<ButtonCompo
							size="medium"
							type="submit"
							variant="contained"
							name="Skip"
							onClick={this.onSkip}
						/>
						&nbsp;&nbsp;&nbsp;
						{dataResponse.length !== 0 && (
							<ButtonCompo
								size="medium"
								type="submit"
								variant="contained"
								name="Submit"
								onClick={this.onSubmit}
							/>
						)}
					</Grid>
				</Paper>
			</>
		);
	}
}
const mapStateToProps = (state) => ({
	salesTeamList: state.salesExecutive,
});
const mapDispatchToProps = {
	showLoador,
	showNotification,
	getReportingManagerHierarchy,
	setReportingManagerHierarchy,
};

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(BeatAssignationBySalesTeamWise);
